/**
 * Verification API
 * For email verification in public forms
 */
import axios from './axios'

export const verificationApi = {
    /**
     * Send verification code to email
     */
    sendCode: (email, formId, language = 'en') => {
        return axios.post('/verification/send', { email, form_id: formId, language })
    },

    /**
     * Verify the code
     */
    verifyCode: (email, code, formId) => {
        return axios.post('/verification/verify', { email, code, form_id: formId })
    },

    /**
     * Check if email is verified
     */
    checkVerified: (email, formId) => {
        return axios.get(`/verification/check?email=${encodeURIComponent(email)}&form_id=${formId}`)
    },
}
